import { Component, Input } from '@angular/core';
import { AlertLineData } from './alert-line-data';

@Component({
	selector: 'app-alert-line',
	templateUrl: './alert-line.component.html',
	styleUrls: ['./alert-line.component.scss']
})
export class AlertLineComponent {

	@Input() alertLineData: AlertLineData = new AlertLineData();

	constructor() {}

	public resetAllMessages() {
		this.alertLineData.resetAllMessages();
	}
}
